import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useApi } from "../../lib/useApi";
import { api } from "../../lib/api";
import { fmtDate } from "../../lib/labels";

export default function NotificationBell({ base = "/company/notifications" }) {
  const { data, reload } = useApi(base);
  const navigate = useNavigate();
  const unread = data?.unread || 0;

  const open = async (n) => {
    if (!n.read) {
      await api.post(`${base}/${n.id}/read`);
      reload();
    }
    if (n.link) navigate(n.link);
  };

  return (
    <Popover onOpenChange={(o) => { if (o) { reload(); } }}>
      <PopoverTrigger asChild>
        <button data-testid="notifications-button" className="relative rounded-full p-2 text-slate-600 transition-colors hover:bg-slate-100" aria-label="Notifications">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notifications-unread-count" className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white">{unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <p className="font-display text-sm font-semibold">Notifications</p>
          {unread > 0 && (
            <button data-testid="notifications-read-all" className="text-xs font-medium text-blue-600 hover:underline"
              onClick={async () => { await api.post(`${base}/read-all`); reload(); }}>Tout marquer lu</button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {!data?.items?.length && <p className="px-4 py-8 text-center text-sm text-slate-500">Aucune notification</p>}
          {data?.items?.map((n) => (
            <button key={n.id} onClick={() => open(n)} data-testid={`notification-item-${n.id}`}
              className={`block w-full border-b px-4 py-3 text-left transition-colors hover:bg-slate-50 ${n.read ? "" : "bg-blue-50/50"}`}>
              <p className="text-sm font-medium text-slate-800">{n.title}</p>
              <p className="line-clamp-2 text-xs text-slate-500">{n.message}</p>
              <p className="mt-1 text-[11px] text-slate-400">{fmtDate(n.created_at)}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
